import React, { useState, useEffect } from "react";
import axios from "axios";
import { Card, Col, Form, Row, Button, Container } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  createDailyExpense,
  resetExpenseCreate,
} from "../features/dailyexpense/dailyExpenseSlice";
import { toast } from "react-toastify";
import Loader from "../components/Loader";
import { logout } from "../features/user/userSlice";

const DailyExpenseEntry = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [expenseAmount, setExpenseAmount] = useState("");
  const [expenseDescription, setExpenseDescription] = useState("");

  //user selector
  const { userInfo } = useSelector((state) => state.user);

  const {
    expense,
    isCreateLoading,
    isCreateError,
    isCreateSuccess,
    createErrorMessage,
  } = useSelector((state) => state.dailyExpense);

  useEffect(() => {
    if (!userInfo) {
      toast.error("Please Login To Get Access!!", { position: "top-center" });
      navigate("/login");
    }
    if (userInfo.permissions?.includes("dailyExpenseEntry") === false) {
      toast.error("Paknami Keno Koren???", {
        position: "top-center",
      });
      dispatch(logout());
    }
  }, [userInfo, navigate, dispatch]);

  useEffect(() => {
    if (isCreateSuccess) {
      toast.success("Expense Created Successfully", {
        position: "top-center",
      });
      navigate("/dailyExpense");
    } else if (isCreateError) {
      toast.error(createErrorMessage, {
        position: "top-center",
      });
    }
  }, [isCreateSuccess, isCreateError, createErrorMessage, navigate, expense]);

  useEffect(() => {
    return () => {
      dispatch(resetExpenseCreate());
    };
  }, [dispatch]);

  const submitHandler = (e) => {
    e.preventDefault();
    if (expenseAmount !== "" && expenseDescription !== "") {
      dispatch(
        createDailyExpense({
          amount: expenseAmount,
          description: expenseDescription,
        })
      );
    } else {
      toast.error("Please fill all the fields", {
        position: "top-center",
      });
    }
  };

  return (
    <Container fluid className="my-4">
      <Row className="mb-4">
        <Card
          className="rounded-4 border"
          style={{ backgroundColor: "#e6edf1" }}
        >
          <h2 className="my-3 text-dark text-center fw-bold">
            Daily <span style={{ color: "#5c91dc" }}>Expense</span> Entry
          </h2>
        </Card>
      </Row>
      <>
        {isCreateLoading ? (
          <Loader />
        ) : (
          <Form onSubmit={submitHandler}>
            <Row>
              {/* Column For Form */}
              <Col sm={12} md={12} lg={12}>
                <Card className="mb-4 shadow rounded">
                  <Card.Header
                    as="h5"
                    className="p-3 text-center text-black fw-bold"
                    style={{ backgroundColor: "#74a2e3" }}
                  >
                    Expense Entry
                  </Card.Header>
                  <Card.Body>
                    <Row>
                      <Col sm={12} md={6} lg={6}>
                        <Form.Group controlId="expenseAmount">
                          <Form.Label style={{ color: "black" }}>
                            Expense Amount
                          </Form.Label>
                          <Form.Control
                            required
                            type="number"
                            placeholder="Expense Amount"
                            value={expenseAmount}
                            onChange={(e) => setExpenseAmount(e.target.value)}
                          ></Form.Control>
                        </Form.Group>
                      </Col>
                      <Col sm={12} md={6} lg={6}>
                        <Form.Group controlId="expenseDescription">
                          <Form.Label style={{ color: "black" }}>
                            Expense Description
                          </Form.Label>
                          <Form.Control
                            required
                            type="text"
                            placeholder="Enter Expense Description"
                            value={expenseDescription}
                            onChange={(e) =>
                              setExpenseDescription(e.target.value)
                            }
                          ></Form.Control>
                        </Form.Group>
                      </Col>
                    </Row>

                    <Row className="px-3 mt-4 mb-1">
                      <Button
                        variant="outline-primary"
                        type="submit"
                        className="rounded"
                      >
                        Submit
                      </Button>
                    </Row>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          </Form>
        )}
      </>
    </Container>
  );
};

export default DailyExpenseEntry;
